import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/roles', data)
    .then(response => response.data)
}

function update(data, id) {
  return axios.patch(`/roles/${id}`, data)
    .then(response => response.data)
}

export default {
  fetch(params) {
    return axios.get('/roles', { params: params })
      .then(response => response.data)
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  }
}
